let pricingDistributionObserver: MutationObserver | null = null;

type Band = { label: string; share: number };
const youngBands: Band[] = [{ label: '¥40–69', share: 10 }, { label: '¥70–99', share: 20 }, { label: '¥100–149', share: 45 }, { label: '¥150+', share: 25 }];
const coreBands: Band[] = [{ label: '¥70–99', share: 10 }, { label: '¥100–149', share: 15 }, { label: '¥150–199', share: 50 }, { label: '¥200+', share: 25 }];
const matureBands: Band[] = [{ label: '¥150–199', share: 45 }, { label: '¥200–299', share: 30 }, { label: '¥300+', share: 25 }];
// Weighted by the confirmed product mix: 18–24 15%, 24–28 60%, 28–35 25%.
const overallBands: Band[] = [{ label: '¥40–69', share: 1.5 }, { label: '¥70–99', share: 9 }, { label: '¥100–149', share: 15.75 }, { label: '¥150–199', share: 45 }, { label: '¥200–299', share: 22.5 }, { label: '¥300+', share: 6.25 }];

function formatShare(value: number) { return Number.isInteger(value) ? `${value}%` : `${value.toFixed(2).replace(/0+$/, '').replace(/\.$/, '')}%`; }

function applyCard(selector: string, bands: Band[], mainLabel: string) {
  const card = document.querySelector<HTMLElement>(selector);
  if (!card) return;
  const list = card.querySelector<HTMLElement>('.price-list');
  if (list) list.innerHTML = bands.map(band => `<div class="price-chip"><b>${band.label}</b> · ${formatShare(band.share)}</div>`).join('');
  const bar = card.querySelector<HTMLElement>('.price-distribution');
  if (bar) bar.innerHTML = bands.map(band => `<span style="width:${band.share}%" title="${band.label} ${formatShare(band.share)}"></span>`).join('');
  const main = card.querySelector<HTMLElement>('.main-price-band');
  if (main) main.textContent = mainLabel;
}

function applyOverallPriceBands() {
  const overview = document.querySelector<HTMLElement>('.portfolio-price-overview');
  if (!overview) return;
  const kpis = overview.querySelectorAll<HTMLElement>('.portfolio-price-kpi b');
  if (kpis[0]) kpis[0].textContent = '¥150–199';
  if (kpis[1]) kpis[1].textContent = '45%';
  const bar = overview.querySelector<HTMLElement>('.portfolio-price-bar');
  if (bar) bar.innerHTML = overallBands.map(band => `<span style="width:${band.share}%" title="${band.label} ${formatShare(band.share)}"></span>`).join('');
  overview.querySelectorAll<HTMLElement>('.portfolio-price-item').forEach((item, index) => {
    const band = overallBands[index];
    if (!band) return;
    const label = item.querySelector<HTMLElement>('.portfolio-price-band-label');
    const value = item.querySelector<HTMLElement>('.portfolio-price-value');
    if (label) label.textContent = band.label;
    if (value) value.textContent = formatShare(band.share);
  });
  const note = overview.querySelector<HTMLElement>('.portfolio-price-note');
  if (note) note.innerHTML = '<b>整体价格结构｜</b>¥150–199为核心成交带，占45%；¥200–299为品质升级带，占22.5%；¥300以上为高端试探带，占6.25%。';
  const conclusion = document.querySelector<HTMLElement>('.strategy-conclusion-copy');
  if (conclusion) conclusion.textContent = '18–24岁：¥40–69占10%、¥70–99占20%、¥100–149占45%、¥150以上占25%；24–28岁：¥70–99占10%、¥100–149占15%、¥150–199占50%、¥200以上占25%；28–35岁：¥150–199占45%、¥200–299占30%、¥300以上占25%。按15% / 60% / 25%的货盘权重计算，全品牌¥150–199占45%，是核心成交价格带。';
}

function applyPricingDistributionAdjustment() {
  const overview = document.querySelector<HTMLElement>('.portfolio-price-overview');
  if (!overview || overview.dataset.pricingDistributionVersion === '2026-08-22-v1') return;
  applyCard('.strategy-age-card.young', youngBands, '主力价格带｜¥100–149（占45%）');
  applyCard('.strategy-age-card.core', coreBands, '主力价格带｜¥150–199（占50%）');
  applyCard('.strategy-age-card.mature', matureBands, '主力价格带｜¥150–199（占45%）');
  applyOverallPriceBands();
  overview.dataset.pricingDistributionVersion = '2026-08-22-v1';
}

export function mountPricingDistributionAdjustment() {
  applyPricingDistributionAdjustment();
  if (pricingDistributionObserver) return;
  const content = document.querySelector('#content') || document.body;
  pricingDistributionObserver = new MutationObserver(applyPricingDistributionAdjustment);
  pricingDistributionObserver.observe(content, { childList: true, subtree: true });
}
